import AxiosService from './../Services/AxiosService';
export default async function initializeApplication(): Promise<number> {
    const axios = new AxiosService();
    const result = await axios.axiosInstance.get('config.json?v=' + new Date().toISOString());
    window.$config = result.data || {};
    window.$config.EnableSenderTemplate = false;
    window.$config.messageTemplateRegulationsPdfUrl = '';
    window.$config.messageTemplateVipPackage = false;
    window.$config.messageTemplateSpeedUpApprovalDisabled = true;
    window.$config.messageTemplatePaymentPhaseEnabled = false;

    try {
        const features = await axios.axiosInstance.get('api/client-features');
        if (features && features.data) {
            window.$config.EnableSenderTemplate = features.data.enableSenderTemplate === true;
            window.$config.messageTemplateRegulationsPdfUrl = features.data.messageTemplateRegulationsPdfUrl || '';
            window.$config.messageTemplateVipPackage = features.data.messageTemplateVipPackage === true;
            window.$config.messageTemplateSpeedUpApprovalDisabled = features.data.messageTemplateSpeedUpApprovalDisabled !== false;
            window.$config.messageTemplatePaymentPhaseEnabled = features.data.messageTemplatePaymentPhaseEnabled === true;
        }
    } catch (error) {
        window.$config.EnableSenderTemplate = false;
    }

    const p = Promise.resolve(1);
    return p;
}
